module.exports = __webpack_public_path__ + "media/images/v2/header-4-d13f6b1ca1df6d456d841f9ad798e23a.png";